import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchEnviosSearch } from '../../../../../../redux/envios';
import { CustomTooltip } from '../../../shared/helpers/functionalities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { MenuItem, Select } from '@mui/material';
import EnvioDetalleModal from '../EnviosMetrics/components/EnvioDetalleModal';


const EnvioSearchModal = ({search}) => {
    const dispatch = useDispatch();
    const shippingResults = useSelector((state) => {
        return state.envios.shippingResults;
    });
    const [searchParams, setSearchParams] = useState({
        searchBy: search ? 'codigo_transporte' : 'presupuesto',
        searchValue: search ? search.search : '',
    });

    const handleOnChange = (e) => {
        setSearchParams((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const submitSearch = (newPage) => {
        if (!searchParams.searchValue) {
            return toast.error('El valor de búsqueda no puede estar vacio!');
        }
        dispatch(fetchEnviosSearch(searchParams, newPage));
    };

	const getMenuItemTooltipValue = () => {
        switch(searchParams.searchBy) {
            case 'presupuesto':
                return 'Presupuesto: "P-0000000" o "0000000".';
			case 'pieza_id':
				return 'Pieza ID: 000000.';
            case 'cliente':
                return 'Teléfono o nombre del cliente.';
			case 'codigo_transporte':
				return 'Envío: "E-0000000", "0000000"';
            case 'seguimiento':
                return 'Envío: Número de seguimiento.';
            default:
                return '';
        }
    }

	useEffect(() => {
	  if(search?.key === 'envio') {
		submitSearch(1)
	  }
	}, [])
	

    return (
        <div className='envio-search-modal'>
            <div className='envio-search-modal__header pb-1'>
				<CustomTooltip
					title={<p className="m-0">{getMenuItemTooltipValue()}</p>}
				>
					<span style={{cursor: 'pointer'}}>
						<FontAwesomeIcon icon={faInfoCircle} size="lg" className="action" color="#215731" /> 
					</span>
				</CustomTooltip>
                <Select
                    size="small"
                    name="searchBy"
                    onChange={handleOnChange}
                    value={
                        searchParams.searchBy
                            ? searchParams.searchBy
                            : 'presupuesto'
                    }
                >
                    <MenuItem value={'presupuesto'}>{'Presupuesto'}</MenuItem>
                    <MenuItem value={'pieza_id'}>{'Pieza ID'}</MenuItem>
                    <MenuItem value={'cliente'}>
                        {'Cliente'}
                    </MenuItem>
                    <MenuItem value={'codigo_transporte'}>
                        {'Código Transporte'}
                    </MenuItem>
                    <MenuItem value={'seguimiento'}>{'Seguimiento'}</MenuItem>
                </Select>
                <input
                    value={searchParams.searchValue}
                    name="searchValue"
                    onChange={handleOnChange}
					className="form-control"
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
						  submitSearch(1);
						}
					}}
                />
                <button
                    onClick={() => submitSearch(1)}
                    className="btn btn-primary"
                >
                    Buscar
                </button>
            </div>
            {shippingResults && (
                <div className="pt-3">
                    <EnvioDetalleModal getShippingNewPage={submitSearch} shippingResults={shippingResults} />
                </div>
            )}
        </div>
    );
};

export default EnvioSearchModal;
